export const settings = {
    header: "設定",
    items: {
        motion: {
            label: "モーションの減少",
        },
        contrast: {
            label: "ハイコントラストモード",
        },
    },
};
